import {
  type AllDualVariantIconKeys,
  type AllIconKeys,
  type AllSingleVariantIconKeys,
  Body,
  Box,
  Icon,
  type IconVariant,
  Stack,
} from "@biom3/react";

export interface KeyInfoProps {
  icon: AllIconKeys | AllDualVariantIconKeys | AllSingleVariantIconKeys | "Key";
  variant?: IconVariant | undefined;
  title: string;
  value: string;
}

export const KeyInfo = ({
  icon,
  title,
  value,
  variant = "bold",
}: KeyInfoProps) => {
  return (
    <Box
      sx={{
        p: "base.spacing.x4",
        bg: "base.color.translucent.emphasis.100",
        borderRadius: "base.borderRadius.x6",
        flex: 1,
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Stack
        direction="column"
        gap="0"
        sx={{ alignItems: "center", display: "flex", width: "100%" }}
      >
        <Icon
          // biome-ignore lint/suspicious/noExplicitAny: icon keys has crappy type
          icon={icon as any}
          variant={variant}
          sx={{ w: "base.icon.size.300", mb: "base.spacing.x1" }}
        />
        <Body
          size="xSmall"
          sx={{
            color: "base.color.text.body.secondary",
            textAlign: "center",
          }}
        >
          {title}
        </Body>
        <Body
          size="xSmall"
          weight="bold"
          sx={{
            textAlign: "center",
          }}
        >
          {value}
        </Body>
      </Stack>
    </Box>
  );
};
